import { PracticeMultiSelect } from '../../shared/PracticeMultiSelect';

export interface CalendarPractice {
    id: string;
    name: string | null;
}

interface PracticeFilterListProps {
    selected: CalendarPractice[];
    onChange: (next: CalendarPractice[]) => void;
}

// Adds the "PRACTICE · N" section label around the shared picker - rows stay
// inert (no `onNavigate`) and an empty selection means "show all".
export function PracticeFilterList({ selected, onChange }: PracticeFilterListProps) {
    return (
        <div className="flex flex-col gap-2">
            <span className="text-[11px] font-medium text-gray-400 uppercase tracking-wider">
                Practice
                {selected.length > 0 && <> &middot; {selected.length}</>}
            </span>
            <PracticeMultiSelect
                selected={selected}
                onChange={onChange}
                placeholder="Search a practice"
                emptyText="All practices shown."
            />
        </div>
    );
}
